export const getContactKey = (lastName, firstName, middleName, cntId) => {
  return (
    //lastName + ' ' + firstName + ' ' + middleName + ' ' + '(' + cntId + ')'
    lastName + ' ' + firstName + ' ' + middleName
  );
};

export const getContactName = (lastName, firstName, middleName) => {
  return firstName + ' ' + middleName + ' ' + lastName;
};
